import { useNavigate } from 'react-router';
import { useShop } from '../app/boot.tsx';
import { Page } from '../ui/index.tsx';

/** Default notice used until the shop writes its own (template; the shop must review it with a legal advisor). */
export function defaultPrivacyNotice(shopName: string): string {
  return [
    `${shopName} ("ร้าน") เก็บข้อมูลส่วนบุคคลของคุณเท่าที่จำเป็นเพื่อให้บริการจองคิว ได้แก่ ชื่อ เบอร์โทรศัพท์ รหัสผู้ใช้ LINE และประวัติการจอง`,
    'วัตถุประสงค์: ยืนยันและแจ้งเตือนการจอง ติดต่อกรณีมีการเปลี่ยนแปลง และดูแลประวัติการใช้บริการ',
    'ร้านใช้ระบบ SalonFlow เป็นผู้ประมวลผลข้อมูลแทนร้าน ข้อมูลจะไม่ถูกขายหรือเปิดเผยแก่บุคคลอื่น เว้นแต่กฎหมายกำหนด',
    'ระยะเวลาเก็บ: ตลอดระยะเวลาที่คุณเป็นสมาชิก หรือจนกว่าคุณจะขอลบข้อมูล',
    'สิทธิของคุณ: ขอดู แก้ไข หรือลบข้อมูลได้ที่เมนู "โปรไฟล์" หรือติดต่อร้านโดยตรง',
  ].join('\n\n');
}

export function Privacy() {
  const { shop } = useShop();
  const navigate = useNavigate();
  const text = shop.privacyNotice?.trim() || defaultPrivacyNotice(shop.name);
  return (
    <Page title="นโยบายความเป็นส่วนตัว" back={() => navigate(-1)}>
      <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>
    </Page>
  );
}
